<div class="block-container">
  <a id="file-{{block.content.id}}" class="title" href="{{block.content.file | bucket:'medias'}}" target="_blank" rel="noopener">
    <img alt="Arquivo pdf" src="/assets/icons_custom/ic-pdf.svg">
    <span class="align-middle link file-name">{{ block.title }}</span>
  </a>
</div>
